module.exports = __webpack_public_path__ + "img/visa-internacional.945e20df.png";